import { useCallback, useEffect, useState } from 'react'

import { Input } from './Input'
import { Select } from './Select'

import AreasMapper from '../../Utils/AreasMapper'
import CountriesMapper from '../../Utils/CountriesMapper'
import LevelsMapper from '../../Utils/LevelsMapper'
import List from '../../API/Lists/Lists'

import { debounce } from '../../libs/debounce'

export function Filter({ setFilters, filters }) {
	const [query, setQuery] = useState(null)
	const [lists, setLists] = useState(null)

	const load = useCallback(async () => {
		const [areasRes, countriesRes, levelsRes] = await Promise.all([List.areas(), List.countries(), List.levels()])

		const areas = areasRes?.map(AreasMapper.toDomain)
		const countries = countriesRes?.map(CountriesMapper.toDomain)
		const levels = levelsRes?.map(LevelsMapper.toDomain)

		setLists({
			areas,
			countries,
			levels,
		})
	}, [])

	useEffect(() => {
		load()
	}, [load])

	const handleFilter = event => {
		setFilters({
			...filters,
			[event.target.name]: event.target.value,
		})
	}

	const handleClearFilter = () => {
		setFilters(null)
	}

	const debouncedTeste = useCallback(debounce(handleFilter, 1000), []) // 300ms debounce time

	const handleInputChange = event => {
		const value = event.target.value
		setQuery(value)
		debouncedTeste(event)
	}

	if (!lists) return <></>

	return (
		<div className='tw-mb-2 tw-flex tw-items-center tw-gap-2 tw-w-full'>
			<Input onChange={handleInputChange} value={query || filters?.name || ''} placeholder='Nome' name='name' />
			<Select placeholder='País' list={lists.countries} onChange={handleFilter} name='country' value={filters?.country || null} />
			<Select placeholder='Area' list={lists.areas} onChange={handleFilter} name='area' value={filters?.area || null} />
			<Select placeholder='Nível Jerárquico' list={lists.levels} onChange={handleFilter} name='level' value={filters?.level || null} />
			<button className='border tw-bg-white tw-rounded-md tw-p-2 tw-h-full tw-w-full tw-max-w-[200px]' onClick={handleClearFilter}>
				Limpar Filtros
			</button>
		</div>
	)
}
